import { JButton } from '@atoms/JButton';
import { FormControl, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface AcceptanceDialogBodyProps {
  onClose: () => void;
  onConfirm: () => void;

  candidateName: string;
  cvVideoName: string | undefined;
}
const CvVideoAcceptanceDialogBody = ({
  onClose,
  candidateName,
  onConfirm,
  cvVideoName,
}: AcceptanceDialogBodyProps) => {
  const { t } = useTranslation();

  return (
    <FormControl>
      <Typography>
        {t('ACCEPT_CONFIRM')} <strong>{cvVideoName} </strong>du candidat{' '}
        <strong>{candidateName}</strong>
      </Typography>

      <Stack direction={'row'} gap={1} mt={2}>
        <JButton
          data-qa="confirm-button"
          onClick={onConfirm}
          variant="contained"
          color="secondary"
          fullWidth
        >
          {t('ACCEPT')}
        </JButton>
        <JButton
          data-qa="close-button-on-acceptance-dialog"
          onClick={onClose}
          variant="contained"
          color="info"
        >
          {t('CANCEL')}
        </JButton>
      </Stack>
    </FormControl>
  );
};

export default CvVideoAcceptanceDialogBody;
